import { AccountInfo } from '@azure/msal-browser';

import { loginRequest } from '@/app/config/auth/msalConfig';
import { msalInstance } from '@/app/config/auth/msalInstance';

class TokenService {
  async getAccessToken(): Promise<string | null> {
    const account = this.getFirstAccount();
    if (!account) {
      return null;
    }

    return (
      (await this.tryAcquireTokenSilently(account)) ||
      (await this.tryAcquireTokenWithPopup())
    );
  }

  private getFirstAccount(): AccountInfo | null {
    const accounts = msalInstance.getAllAccounts();
    return accounts[0] || null;
  }

  private async tryAcquireTokenSilently(
    account: AccountInfo,
  ): Promise<string | null> {
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      return response.accessToken;
    } catch (error) {
      console.warn('Silent token acquisition failed:', error);
      return null;
    }
  }

  private async tryAcquireTokenWithPopup(): Promise<string | null> {
    try {
      const response = await msalInstance.acquireTokenPopup(loginRequest);
      return response.accessToken;
    } catch (error) {
      console.error('Popup token acquisition failed:', error);
      return null;
    }
  }
}

export const tokenService = new TokenService();
